import React, { useEffect } from "react";
import { FaShieldAlt, FaBalanceScale, FaUserTie, FaComments, FaCalculator, FaBuilding, FaHome, FaGavel } from "react-icons/fa";
import { GiCalculator } from 'react-icons/gi';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger'; // For scroll animations
import "../Services/Services.css";

gsap.registerPlugin(ScrollTrigger); // Register ScrollTrigger plugin

const servicesData = [
  { title: "Tax Planning", description: "It is a long established fact that a reader will be distracted.", icon: <FaShieldAlt className="service-icon" /> },
  { title: "Audit Services", description: "It is a long established fact that a reader will be distracted.", icon: <FaBalanceScale className="service-icon" /> },
  { title: "Compliance Experts", description: "It is a long established fact that a reader will be distracted.", icon: <FaUserTie className="service-icon" /> },
  { title: "Free Consultation", description: "It is a long established fact that a reader will be distracted.", icon: <FaComments className="service-icon" /> },
  { title: "Tax Advisory", description: "It is a long established fact that a reader will be distracted.", icon: <FaCalculator className="service-icon" /> },
  { title: "Corporate Services", description: "It is a long established fact that a reader will be distracted.", icon: <FaBuilding className="service-icon" /> },
  { title: "GST Filing", description: "It is a long established fact that a reader will be distracted.", icon: <FaHome className="service-icon" /> },
  { title: "Business Advisory", description: "It is a long established fact that a reader will be distracted.", icon: <FaGavel className="service-icon" /> },
];


// Duplicate the servicesData to extend the scroll effect
const extendedServicesData = [...servicesData, ...servicesData];

const Services = () => {
  useEffect(() => {
    // Zoom in effect on the main text
    gsap.to(".main-heading-pcs", {
      scale: 1.3,
      duration: 5,
      ease: "power2.out", // Smooth easing for smoother transitions
      delay: 1.5, // Delay before animation starts
      scrollTrigger: {
        trigger: ".main-heading-pcs",
        start: "top center",
        end: "bottom center",
        scrub: 1, // Smooth scrubbing for better control
        toggleActions: "restart none reverse none",
      }
    });

    // Horizontal movement for the entire grid on scroll with start and end positions
    gsap.to(".services-section", {
      x: "-100%", // Move grid to the left by 100%
      duration: 5,
      ease: "none", // Smooth, linear motion
      scrollTrigger: {
        trigger: ".services-section",
        start: "top center", // Start when the section enters the middle of the viewport
        end: () => `+=${document.querySelector('.services-section').offsetWidth - (2 * 200)}px`, // End when only 4 cards are visible
        scrub: 1, // Scrub for smooth scroll-based animation
        toggleActions: "restart none reverse none",
      }
    });

    // Animation for each service item (fade in and slide from the bottom)
    extendedServicesData.forEach((_, index) => {
      gsap.fromTo(
        `.service-items:nth-child(${index + 1})`, 
        { opacity: 0, y: 50 }, 
        {
          opacity: 1, 
          y: 0, 
          duration: 1.5, 
          ease: "power2.out",
          scrollTrigger: {
            trigger: `.service-items:nth-child(${index + 1})`,
            start: "top bottom", 
            end: "bottom center", 
            scrub: true,
            toggleActions: "restart none reverse none",
          }
        }
      );
    });
  }, []);

  return (
    <>
      <div className="full-s">
        <div className="decorated-heading-pcs">
          <GiCalculator className="react-icon-pcs" />
        </div>
        <h1 className="main-heading-pcs">Services Provide</h1>
        <p className="description-pcs">
  If you need assistance with taxation or compliance, you will need the very best chartered accountants in India. We are especially skilled in the following service areas.
</p>

        <div className="services-section">
          {extendedServicesData.map((service, index) => (
            <div className="service-items" key={index}>
              <div className="icon-boxs">
                {service.icon}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Services;
